import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@mui/material';
import { CloseIcon } from '@shared/ui/CloseIcon';
import styles from './DialogCloseButton.module.scss';
export function DialogCloseButton({ onClick }) {
    return (_jsx(IconButton, { className: styles.closeBtn, "aria-label": "close", onClick: onClick, children: _jsx(CloseIcon, {}) }));
}
